import React from "react";
import "./score.css";

export default ({ scores, team, classes, handler, question }) => {
  const [a, b] = scores;
  const aclasses = team === "A" ? "selected" : "";
  const bclasses = team === "B" ? "selected" : "";
  return (
    <div className={`score-card ${classes}`} onClick={handler}>
      <div className="question-no">Question No: {question}</div>
      <div className={`score ${aclasses}`}>
        <span>A</span>
        {a}
      </div>
      <div className={`score ${bclasses}`}>
        <span>B</span>
        {b}
      </div>
    </div>
  );
};
